import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "./EntityCommand";
import { EntityCommandInformation } from "./EntityCommandInformation";
import { PartialNullable } from "./Extensions";
import { NAMESPACE } from "./_Namespace";
import { Property } from "./RadObject";
import { OrEvaluator } from "./Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/OrEvaluator";
import { PermissionEvaluator } from "./Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { TeamEvaluator } from "./Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/TeamEvaluator";
import { ServerErrorHelper } from "./Server/ServerErrorHelper";
import { WebApiClientService } from "./Server/WebApiClientService";
import { ServiceManager } from "./ServiceManager";
import { ErrorDialog } from "./Ui/Controls/ErrorDialog";
import { MessageDialog } from "./Ui/Controls/MessageDialog";
import { Constants } from "./Constants";

export type EntityCommandTeamsRebuildPermissionsPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandTeamsRebuildPermissionsProperties = {
    [name in keyof EntityCommandTeamsRebuildPermissionsPropertyValues]: Property<EntityCommandTeamsRebuildPermissionsPropertyValues[name]>
};

export interface IEntityCommandTeamsRebuildPermissions extends IEntityCommand, EntityCommandTeamsRebuildPermissionsProperties
{
}

export class EntityCommandTeamsRebuildPermissions extends EntityCommand<EntityCommandTeamsRebuildPermissionsPropertyValues> implements IEntityCommandTeamsRebuildPermissions
{
    public static override classNamespace = NAMESPACE + "EntityCommandTeamsRebuildPermissions";
    public static override className = "EntityCommandTeamsRebuildPermissions";

    // #region Static

    // #region Private Methods

    public static async rebuildPermissionsAsync()
    {
        try
        {
            await (
                ServiceManager.getRequired(WebApiClientService)
                    .createApiMethodRequest("Security", "RebuildPermissions")
                    .executeAsync()
            );

            MessageDialog.displayMessage("Rebuild Permissions", "Permissions have been rebuilt.")
        }
        catch (xhr: any)
        {
            const
                error = ServerErrorHelper.processError(xhr);

            ErrorDialog.displayError(error)

            throw error;
        }
    }

    // #endregion

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandTeamsRebuildPermissionsPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Rebuild Permissions",
                entityName: "Team",
                key: "TEAM_REBUILD_PERMISSIONS",
                permission: PermissionEvaluator.permissionLevels.execute,
                type: EntityCommandTypeEnum.entitySet,
                visibleEvaluator: new OrEvaluator({ evaluators: [new TeamEvaluator({ teamName: Constants.TeamNames.SYSTEM_ADMINISTRATORS }), new TeamEvaluator({ teamName: Constants.TeamNames.ADMINISTRATION_SYSTEM_USERS })] }),
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandTeamsRebuildPermissionsPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value: any)
    {
        await super._executeAsync(entityCommandInformation, value);
        await EntityCommandTeamsRebuildPermissions.rebuildPermissionsAsync();
    }

    // #endregion

    // #endregion
}

